<script lang="ts" setup>
// Properties
const props = defineProps({
    type: {
        type: String,
        default: "button",
    },
    px: {
        type: String,
        default: "px-6",
    },
    py: {
        type: String,
        default: "py-2.5",
    },
});

// Data
</script>

<template>
    <NuxtLink
        v-if="type.toLowerCase() === 'link'"
        class="border-primary bg-primary hover:border-abc-blue hover:bg-abc-blue focus:bg-abc-blue active:border-primary-darker active:bg-primary-darker dark:ring-offset-abc-blue inline-block rounded-full border-2 text-center text-white no-underline! focus:border-white focus:text-white focus:ring-1 focus:ring-offset-1 active:text-white disabled:border-gray-300 disabled:bg-gray-300 disabled:text-white"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </NuxtLink>
    <button
        v-else
        :type="type"
        class="border-primary bg-primary hover:border-abc-blue hover:bg-abc-blue focus:bg-abc-blue active:border-primary-darker active:bg-primary-darker dark:ring-offset-abc-blue rounded-full border-2 text-center font-semibold text-white focus:border-white focus:text-white focus:ring-1 focus:ring-offset-1 active:text-white disabled:border-gray-300 disabled:bg-gray-300 disabled:text-white"
        :class="px + ' ' + py"
    >
        <slot></slot>
    </button>
</template>
